SectionProfile.Event.Payment = Class(
    /**
     * @lends {SectionProfile.Event.Payment#}
     */
    {
        __NAME: 'SectionProfile.Event.Payment',
        bodyClass: 'small-nav grey hide-tablet-footer',
        name: 'team-payment',
        TOP_BAR: true,

        route(){
            PARENT.route();

            this.url.shift();
            this.paymentMethod = this.url.shift()
            this.paymentId = Number(this.url.shift());
            if (!D.APP_WEBVIEW) {
                Section.navigate(D.url('/event/' + this.event.seoTitle));
            }
        },

        _draw() {
            this.node = mkE({
                tag: 'div',
                id: 'profile-team-payment',
                els: [
                    this._everyPayMobile = new T.EveryPayMobile({
                        paymentMethod: this.paymentMethod,
                        paymentId: this.paymentId,
                        apiCall: this.apiCall,
                    }),
                ]
            }).append(this._content);
        },

        _ready() {
            this._drawSidebar({
                purchase: true
            });

            this._everyPayMobile.draw();
        },
    },
    SectionProfile.EventBase
);
